// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1NJS7","filesListContainer":"PosDisputesFiles_filesListContainer__o9jIz","filesButton":"PosDisputesFiles_filesButton__ZBNLX"};